import React, { Fragment } from 'react';

const PackageInstallation = () => {
    return (
        <Fragment>
            <p style={{margin:'0'}}>npm install zk-minervaiot-im</p>
        </Fragment>
    );
}

export default PackageInstallation;



// WEBPACK FOOTER //
// ./src/components/PackageInstallation/PackageInstallation.js